'use strict';

wbApp.controller('RegisteredAttendanceCtrl', ['$scope', 'reportsSvc',
function ($scope, reportsSvc) {

    var startDate = moment().startOf('month').subtract(1, 'days').startOf('month');

    $scope.fromDate = startDate.toDate();
    $scope.toDate = moment(startDate).endOf('month').toDate();

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.onFromDateChange = function (fromDate) {
        if (fromDate) {
            refreshData(fromDate, $scope.toDate);
        }
    }

    $scope.onToDateChange = function (toDate) {
        if (toDate) {
            refreshData($scope.fromDate, toDate);
        }
    }

    $scope.gridOptions = {
        sortInfo: { fields: ['ClassroomName'], directions: ['dsc'] },
        columnDefs: [{ field: 'ClassroomName', displayName: "TXT_LBL_CLASSROOM", sort: 'locale' }
        ]
    };

    function refreshData(fromDate, toDate) {
        $scope.registeredAttendance = reportsSvc.getRegisteredAttendanceAsync(fromDate, toDate);

        $scope.registeredAttendance.$promise.then(function (data) {
            $scope.gridOptions.columnDefs = [{ field: 'ClassroomName', displayName: "TXT_LBL_CLASSROOM", sort: 'locale' }];
            var newColumnDefs = [];
            if (data.length > 0) {
                for (var prop in data[0]) {                    
                    if (data[0].hasOwnProperty(prop) && prop !== "classroomID" && prop !== "ClassroomName") {
                        newColumnDefs.push({ field: prop, displayName: prop, width: '60px' });
                    }
                }
            }
            var sortedDefs = _.sortBy(newColumnDefs, 'displayName');
            $scope.gridOptions.columnDefs.push.apply($scope.gridOptions.columnDefs, sortedDefs);
        });
    }

    refreshData($scope.fromDate, $scope.toDate);


}]);
